module.exports = __webpack_public_path__ + "img/logo.c25c959a.png";